
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flow",
      function () {
        return require("private-next-pages/flow/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flow"])
      });
    }
  